import { render } from "./FaQ.vue?vue&type=template&id=4e8faa0e&scoped=true"
import script from "./FaQ.vue?vue&type=script&lang=js"
export * from "./FaQ.vue?vue&type=script&lang=js"

import "./FaQ.vue?vue&type=style&index=0&id=4e8faa0e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8faa0e"]])

export default __exports__